import { Button, FileButton, Stack, Text } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';

type IdentityStepProps = {
  idFront: File | null;
  idBack: File | null;
  setIdFront: (file: File | null) => void;
  setIdBack: (file: File | null) => void;
};

export function IdentityStep({ idFront, idBack, setIdFront, setIdBack }: IdentityStepProps) {
  const { t } = useTranslation();

  return (
    <Stack gap="md" mt="md">
      <Text size="sm" c="dimmed">
        {t(i18nKeys.AML_MODAL.IDENTITY.DESCRIPTION)}
      </Text>
      <Stack gap="md" align="center">
        <Text size="sm" fw={500}>
          {t(i18nKeys.AML_MODAL.IDENTITY.ID_FRONT)} *
        </Text>
        <FileButton accept="image/png,image/jpeg" onChange={file => setIdFront(file)}>
          {props => (
            <Button w="20%" leftSection={<IconUpload size={16} />} variant="default" {...props}>
              {idFront ? idFront.name : t(i18nKeys.AML_MODAL.IDENTITY.UPLOAD)}
            </Button>
          )}
        </FileButton>
        <Text size="sm" fw={500}>
          {t(i18nKeys.AML_MODAL.IDENTITY.ID_BACK)} *
        </Text>
        <FileButton accept="image/png,image/jpeg" onChange={file => setIdBack(file)}>
          {props => (
            <Button w="20%" leftSection={<IconUpload size={16} />} variant="default" {...props}>
              {idBack ? idBack.name : t(i18nKeys.AML_MODAL.IDENTITY.UPLOAD)}
            </Button>
          )}
        </FileButton>
      </Stack>
    </Stack>
  );
}
